import { CardHeader } from "reactstrap";
import { StateSavingSpan1, StateSavingSpan2, StateSavingSpan3, StateSavingSpan4, StateSavingTitle } from "../../../../Constant";
import { H3 } from "../../../../AbstractElements";

const StateSavingCardHeader = () => {
  return (
    <CardHeader className="pb-0 card-no-border">
      <H3>{StateSavingTitle}</H3>
      <span dangerouslySetInnerHTML={{ __html: StateSavingSpan1 }} />
      <span dangerouslySetInnerHTML={{ __html: StateSavingSpan2 }} />
      <span dangerouslySetInnerHTML={{ __html: StateSavingSpan3 }} />
      <span dangerouslySetInnerHTML={{ __html: StateSavingSpan4 }} />
    </CardHeader>
  );
};

export default StateSavingCardHeader;
